import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Ga4Tracker from "@/components/Ga4Tracker";
import HomePage from "@/pages/HomePage";
import AdDetailPage from "@/pages/AdDetailPage";
import CreateAdPage from "@/pages/CreateAdPage";
import ManageAdPage from "@/pages/ManageAdPage";
import LookupPage from "@/pages/LookupPage";
import ChatPage from "@/pages/ChatPage";
import ListingChatsPage from "@/pages/ListingChatsPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import TermsPage from "@/pages/TermsPage";
import GdprPage from "@/pages/GdprPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import ReceiptPage from "@/pages/ReceiptPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import ChatDock from "@/components/ChatDock";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Ga4Tracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/kategorie/:category" element={<HomePage />} />
          <Route path="/kategorie/:category/:sub" element={<HomePage />} />
          <Route path="/inzerat/:id" element={<AdDetailPage />} />
          <Route path="/novy-inzerat" element={<CreateAdPage />} />
          <Route path="/sprava-inzeratu/:id" element={<ManageAdPage />} />
          <Route path="/sprava-inzeratu/:id/zpravy" element={<ListingChatsPage />} />
          <Route path="/moje-inzeraty-email" element={<LookupPage />} />
          <Route path="/zpravy" element={<ChatPage />} />
          <Route path="/zpravy/:roomId" element={<ChatPage />} />
          <Route path="/jak-to-funguje" element={<HowItWorksPage />} />
          <Route path="/obchodni-podminky" element={<TermsPage />} />
          <Route path="/gdpr" element={<GdprPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/doklad/:number" element={<ReceiptPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/odhlasit" element={<UnsubscribePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <ChatDock />
        <Toaster theme="dark" position="top-right" />
      </BrowserRouter>
    </div>
  );
}
